import { render, staticRenderFns } from "./DistributionSecondary.vue?vue&type=template&id=8b73c7c6"
import script from "./DistributionSecondary.vue?vue&type=script&lang=js"
export * from "./DistributionSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports